<template>
  <div
    v-if="(platformMaintenance || shopMaintenance) && !adminExempt"
    class="flex min-h-screen w-full flex-col items-center justify-center bg-gradient-to-b from-slate-50 to-indigo-50 px-4 text-center"
  >
    <div class="max-w-lg space-y-4">
      <div class="mx-auto flex size-14 items-center justify-center rounded-2xl bg-indigo-100 text-indigo-600">
        <UIcon name="i-heroicons-sparkles" class="size-7" />
      </div>
      <h1 class="text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
        Revenim imediat
      </h1>
      <p class="text-base leading-relaxed text-slate-600">
        {{ site.name }} e doar pe pauză scurtă. Pregătim ceva nou și ne vedem în curând.
        Mulțumim că ai răbdare.
      </p>
    </div>
  </div>
  <div v-else-if="storefrontLocked && !lockExempt" class="min-h-screen w-full flex flex-col items-center justify-center bg-slate-50 px-4 text-center">
    <div class="max-w-md space-y-3">
      <h1 class="text-2xl font-semibold text-slate-900">Magazin indisponibil</h1>
      <p class="text-slate-600">
        Magazinul public este temporar indisponibil. Abonamentul nu este activ.
      </p>
    </div>
  </div>
  <div v-else class="min-h-screen w-full flex flex-col items-stretch bg-default text-default">
    <a
      href="#main-content"
      class="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-elevated focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-highlighted focus:shadow-lg"
    >
      Salt la conținut
    </a>
    <AppHeader />
    <SiteSearch />
    <main id="main-content" class="flex-1 w-full" tabindex="-1">
      <slot />
    </main>
    <AppFooter />
    <AgeVerificationGate />
  </div>
</template>

<script setup lang="ts">
import { isPublicContPath } from '~/utils/auth-routing'

const appConfig = useAppConfig()
const route = useRoute()
const { storefrontLocked, platformMaintenance, shopMaintenance, site } = useSiteSettings()

const adminExempt = computed(() => /\/admin(\/|$)/.test(route.path))
const lockExempt = computed(() => adminExempt.value || isPublicContPath(route.path))

// Storefront default: flat (solid) buttons.
if (appConfig.ui?.button?.defaultVariants) {
  appConfig.ui.button.defaultVariants.variant = 'solid'
}
</script>
